/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import desktopService from '../services/desktopService';

export const getVersion = createAsyncThunk('desktop/getVersion', async () => {
  const versionAndReleaseNotes = await desktopService.getDesktopVersion();

  return versionAndReleaseNotes;
});

const INITIAL_STATE = { windowsVersion: '', macVersion: '', releaseNotes: [], remindIn: 0, isLoading: false, isError: false };

export const desktopSlice = createSlice({
  name: 'desktop',
  initialState: { ...INITIAL_STATE },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVersion.fulfilled, (state, action) => {
        state.windowsVersion = action.payload.windows_version;
        state.macVersion = action.payload.mac_version;
        state.releaseNotes = action.payload.release_notes;
        state.isLoading = false;
        state.isError = false;
      })
      .addCase(getVersion.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getVersion.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  }
});

export default desktopSlice.reducer;
